import Swiper from 'swiper/bundle';

function initSliderProgramsAndServices() {
	document.querySelectorAll(".slide-programs-and-services-container").forEach(slide => {
		let nextButton;
        let prevButton;

        const buttonsWrapper = slide.parentElement.querySelector(".slide-articles-container__buttons");
        
        if (buttonsWrapper) {
            nextButton = buttonsWrapper.querySelector(".swiper-button-next");
            prevButton = buttonsWrapper.querySelector(".swiper-button-prev");
        } else {
            nextButton = slide.querySelector(".swiper-button-next");
            prevButton = slide.querySelector(".swiper-button-prev");
        }

		const swiper = new Swiper(slide, {
			slidesPerView: "auto",
			spaceBetween: 32,
			centeredSlides: true,
			grabCursor: 'true',

			navigation: {
				nextEl: nextButton,
				prevEl: prevButton,
			},
		});
	});
}

if (document.querySelector(".slide-programs-and-services-container")) {
	initSliderProgramsAndServices();
}
